export const ICONS = {
  COIN: "coin",
  UPGRADE: "upgrade",
  COIN_REVRESH: "coin_revresh",
  PRIZE: "prize",
  SCROLL: "scroll",
  SCORLL_REVRESH: "scroll_revresh",
};
